import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { IInvestmentsState } from './store/investments.state';
import { Observable } from 'rxjs';
import { setInvestmentsAction } from './store/investments.actions';
import { getInvestmentsSelectors } from './store/investments.selectors';
import { IInvestmentsData } from 'src/app/modules/interfaces/investments.interface';
import { InvestmentsService } from 'src/app/services/investments.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-investments',
  templateUrl: './investments.component.html',
  styleUrls: ['./investments.component.scss'],
})
export class InvestmentsComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;
  investmentsData: IInvestmentsData = {
    id: 0,
    has_investiments: null,
    investiment_value: null,
    knows_advisor_fee: null,
    intend_to_invest: null,
  };

  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IInvestmentsState>;
  dataState: IInvestmentsState;

  constructor(
    private store: Store,
    private investmentsService: InvestmentsService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadInvestmentsData();
  }

  loadInvestmentsData(): void {
    this.isLoading = true;
    this.investmentsService
      .getInvestmentsData(this.formsId)
      .subscribe((response) => {
        if (response) {
          this.investmentsData = {
            id: response.id,
            has_investiments: response.has_investiments,
            investiment_value: response.investiment_value || null,
            knows_advisor_fee: response.knows_advisor_fee,
            intend_to_invest: response.intend_to_invest,
          };
        }
        this.saveState();
      });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: Partial<IInvestmentsData> = {
      has_investiments: this.investmentsData.has_investiments,
      investiment_value: this.investmentsData.investiment_value,
      knows_advisor_fee: this.investmentsData.knows_advisor_fee,
      intend_to_invest: this.investmentsData.intend_to_invest,
    };

    this.investmentsService
      .updateInvestmentsData(this.formsId, this.investmentsData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState();
          this.formSaved.emit();
        },
        error: () => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
        },
      });
  }

  saveState(): void {
    this.dataState = {
      ...this.dataState,
      check: true,
      investments: this.investmentsData.has_investiments === 1,
      accessorPayment: this.investmentsData.knows_advisor_fee === 1,
      amount: Number(this.investmentsData.investiment_value) || 0,
      feeModel: this.investmentsData.knows_advisor_fee === 1,
      interest: this.investmentsData.intend_to_invest === 1,
    };

    this.setState(this.dataState);
  }

  updateAmount(event: number): void {
    this.investmentsData.investiment_value = event;
    this.onFieldChange();
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  startTrial(): void {
    this.setState(this.dataState);
  }

  setState(data: IInvestmentsState) {
    this.store.dispatch(setInvestmentsAction(data));
    this.isLoading = false
  }

  getState() {
    this.dataState$ = this.store.select(getInvestmentsSelectors);
    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = false;
    if (this.dataState.investments != undefined) {
      this.dataState.check = true;
    }
    this.setState(this.dataState);
  }

  updateFeeModel(event: boolean): void {
    this.dataState.feeModel = event;
    this.setValuesForm();
  }
}
